import { type StopHandle } from '@/util';
import { type AxesNode, updateAxes } from '@/lib/threeScene/nodes/axes';
import { type AxisNode, updateAxis } from '@/lib/threeScene/nodes/axis';
import { type GridNode, updateGrid } from '@/lib/threeScene/nodes/grid';
import { type GroupNode, updateGroup } from '@/lib/threeScene/nodes/group';
import { type ImagePlaneNode, updateImagePlane } from '@/lib/threeScene/nodes/imagePlane';
import { type MeshNode, updateMesh } from '@/lib/threeScene/nodes/mesh';
import { type PlaneNode, updatePlane } from '@/lib/threeScene/nodes/plane';
import { type SpriteNode, updateSprite } from '@/lib/threeScene/nodes/sprite';
import type { SceneContext } from '@/lib/threeScene/SceneContext';
import { type LineSegmentsNode, updateLineSegments } from '@/lib/threeScene/nodes/lineSegments';

export type StandardNode =
    | AxesNode
    | AxisNode
    | GridNode
    | GroupNode
    | ImagePlaneNode
    | LineSegmentsNode
    | MeshNode
    | PlaneNode
    | SpriteNode;

export function updateNode(context: SceneContext, node: StandardNode): StopHandle {
    switch (node.type) {
        case 'axes':
            return updateAxes(context, node);
        case 'axis':
            return updateAxis(context, node);
        case 'grid':
            return updateGrid(context, node);
        case 'group':
            return updateGroup(context, node);
        case 'image-plane':
            return updateImagePlane(context, node);
        case 'line-segments':
            return updateLineSegments(context, node);
        case 'mesh':
            return updateMesh(context, node);
        case 'plane':
            return updatePlane(context, node);
        case 'sprite':
            return updateSprite(context, node);
        default:
            throw Error(
                `Unknown node with type '${ (node as { type?: string })?.type ?? "undefined"}'`,
            );
    }
}
